import { memo, ReactElement } from "react";
import { setTrackingId } from "client/Misc/utils";
import classNames from "classnames";
import {
	Icon,
	Repeat
} from "client/Components";
import styles from "./VisibilityItemContent.module.less";
import { VisibilityNodeData } from "./common";

export type VisibilityItemContentProps = {
	data: VisibilityNodeData;
	level: number;
	isRoot?: boolean;
	onChange: (data: VisibilityNodeData) => void;
	hasVisibleChildren: boolean;
};

export const VisibilityItemContent = memo(
	(props: VisibilityItemContentProps): ReactElement => {
		const {
			data,
			level,
			isRoot = false,
			onChange,
			hasVisibleChildren
		} = props;

		const toggleCollapsed = (): void => {
			const newNodeState: VisibilityNodeData = {
				...data,
				isCollapsed: !data.isCollapsed
			};

			onChange(newNodeState);
		};

		const TextComponent = isRoot ? "h4" : "span";

		return (
			<div
				{...setTrackingId("item")}
				className={classNames(
					styles.root,
					{
						[styles.root_clickable]: hasVisibleChildren
					}
				)}
				onClick={toggleCollapsed}
			>
				<Repeat amount={level}>
					<div className={styles.indent}></div>
				</Repeat>

				<div className={styles.iconWrapper}>
					{hasVisibleChildren && (
						<Icon
							value={
								data.isCollapsed
									? "chevron-right"
									: "chevron-down"
							}
						/>
					)}
				</div>
				<TextComponent
					className={styles.nodeText}
					title={data.name}
				>
					{data.name}
				</TextComponent>
			</div>
		);
	}
);
VisibilityItemContent.displayName = "VisibilityItemContent";